import { asFoundIPTransmitterSectionData } from './Data/P6142.data';

export const selectAsFoundIPTransmitterSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (['P6-14.2', 'P7-31', 'P6-23.2', 'P6-14'].includes(formName)) {
        filterViewData = asFoundIPTransmitterSectionData(selectedTag, formName, formData);
    }
    return filterViewData;
};
